import Vue from 'vue';
import router from '@/router';
import { modifyChat } from '@/common/helpers/messenger';

export default {
  namespaced: true,
  state: {
    chats: [],
    activeChat: null,
    activeMiniChat: false,
  },
  mutations: {
    addChat: (state, payload) => state.chats.push(payload),
    setChats: (state, payload) => state.chats = payload,
    setActiveChat: (state, payload) => state.activeChat = payload,
    setActiveMiniChat: (state, payload) => state.activeMiniChat = payload,
  },
  actions: {
    async init({ dispatch, commit, state }) {
      await dispatch('getChats');

      // Watch if provider remove clinic admin from chat and then update chats list
      // if (rootState.loggedAccount.account.role === 'CLINIC_ADMIN') {
      //   Vue.prototype.$sockets.chat.on('leave', () => dispatch('getChats'));
      // }

      // Watch all messages for open mini chat
      const excludeRoutes = ['Messenger', 'Login', 'VideoCall'];
      Vue.prototype.$sockets.chat.on('user-message', event => {
        dispatch('getChats');
        // console.log('General message', event);
        if (!excludeRoutes.includes(router.currentRoute.name) && !state.activeMiniChat) {
          dispatch('updateActiveChat', event.roomId).then(() => commit('setActiveMiniChat', true));
        }
      });
    },
    getChats({ commit }) {
      return Vue.prototype.$api.messages.getAllChats().then(({ data }) => {
        commit('setChats', data.payload.map(chat => modifyChat(chat)));
      });
    },
    setActiveChat({ commit, dispatch }, chat) {
      if (chat) {
        commit('setActiveChat', chat.isModified || chat.isNew ? chat : modifyChat(chat));
        if (!chat.isNew && !chat.isFull) dispatch('updateActiveChat', chat.id);
      } else commit('setActiveChat', null);
    },
    updateActiveChat({ commit }, payload) {
      commit('setActiveChat', null);
      if (payload) {
        return Vue.prototype.$api.messages.getChat(payload).then(({ data }) => {
          const chat = modifyChat(data.payload);
          console.dir(chat);
          chat.isFull = true;
          commit('setActiveChat', chat);
          return chat;
        });
      }
    },

    // createChat({ dispatch, state }, initMessage) {
    //   return Vue.prototype.$api.messages.createChat(account.state.account.clinicIds[0], {
    //     userId: state.activeChat.id,
    //     initMessage }).then(({ data }) => Promise.allSettled([
    //     dispatch('getChats'),
    //     dispatch('updateActiveChat', data.payload),
    //   ]));
    // },
  },
};
